<template>
  <ls-search-form :formList="formList" @search="onSearch" ref="searchForm">
    <template #warehouseCode>
      <global-select
        v-decorator="['warehouseCode']"
        @successCallBack="successCallBack"
        requestApi="/system/lookup/data/list"
        selectType="selectMultiple"
        :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        :setParams="{ lookupType: '4PL_WAREHOUSE_DESCRIPTION', pageSize: 1000 }"
      />
    </template>
    <global-select
      slot="planType"
      v-decorator="['planType']"
      selectType="selectFilter"
      requestApi="/system/lookup/data/list"
      :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
      :setParams="{ lookupType: 'INV_ALLOCATION_PLAN_TYPE' }"
    />
    <template #depositAreaCode>
      <global-select
        v-decorator="['depositAreaCode']"
        requestApi="/system/lookup/data/list"
        :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        :setParams="{ lookupType: 'INV_DEFAULT_AREA' }"
      />
    </template>
  </ls-search-form>
</template>
<script>

import moment from 'moment'

export default {
  name: 'MasterControlPlanSearch',
  data () {
    return {

    }
  },
  computed: {
    formList() {
      return [
        {
          label: "入库仓",
          type: "warehouseCode",
          decorator: ['warehouseCode'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: "调度分类",
          type: "planType",
          decorator: ['planType']
        },
        {
          label: "区域",
          type: "depositAreaCode",
          decorator: ['depositAreaCode'],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "早晚班标识",
          type: "select",
          decorator: ['earlyMorningDeliveryIs'],
          options: [
            { key: 0, value: "晚班" },
            { key: 1, value: "早班" }
          ],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "推送状态",
          type: "select",
          decorator: ['status'],
          options: [
            { key: '全量已推送', value: "全量已推送" },
            { key: '部分已推送', value: "部分已推送" },
            { key: '未推送', value: "未推送" }
          ],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "要求到仓日期",
          type: "range",
          decorator: ['originalRequireDeliveryQuantity', { initialValue: [moment().startOf('day').add('1', 'days'), moment().endOf('day').add('1', 'days')] }],
          disposeFormat: {
            requireDeliveryTimeStart: (change) => {
              return change[0].format('YYYY-MM-DD 00:00:00')
            },
            requireDeliveryTimeEnd: (change) => {
              return change[1].format('YYYY-MM-DD 23:59:59')
            }
          }
        }
      ]
    }
  },
  activated() {
    this.$refs.searchForm.form.setFieldsValue({
      originalRequireDeliveryQuantity: [moment().startOf('day').add('1', 'days'), moment().endOf('day').add('1', 'days')]
    })
  },
  methods: {
    onSearch (val) {
      const params = val
      if(params && params.warehouseCode) {
        params.warehouseCode = params.warehouseCode.join(',')
      }
      this.$emit('search', params)
    },
    successCallBack(list) {
      const findName = ['基地仓', '青岛仓库', '佛山仓库']
      findName.forEach(e => {
        const findIndex = list.findIndex(x => x.lookupValue.indexOf(e) > -1)
        if (findIndex > -1) {
          const val = list[findIndex]
          list.splice(findIndex, 1)
          list.unshift(val)
        }
      })
    }
  }
}
</script>
